import { DateRangeSchema } from '@/utils';
import { z } from 'zod';
import { EXPENDITURE_BREAKDOWN_PURPOSES_CODE_LENGTH } from '../utils';
import { getCodeMaxValue } from '../utils/get-code-max-value';
import { AccountingTypeModel } from './accounting-type';
import { ExpenditurePurposeModel } from './expenditure-purpose';

const ExpenditurePurposeOfSettlementStatisticsBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  code: z
    .number()
    .min(1)
    .max(getCodeMaxValue(EXPENDITURE_BREAKDOWN_PURPOSES_CODE_LENGTH)),
  name: z.string(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  level: z.number().int(),
  upperId: z.string().uuid().nullable(),
});

export const ExpenditurePurposesOfSettlementStatisticsModel =
  ExpenditurePurposeOfSettlementStatisticsBaseModel.array();

const ExpenditurePurposeOfSettlementStatisticsPresetBaseModel = z.object({
  id: z.string().uuid(),
  createdAt: z.string(),
  updatedAt: z.string(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  accountingId: z.string().uuid(),
  expenditurePurposeId: z.string().uuid(),
  expenditurePurposeOfSettlementStatisticsId: z.string().uuid(),
});

export const ExpenditurePurposeOfSettlementStatisticsPresetsModel =
  ExpenditurePurposeOfSettlementStatisticsPresetBaseModel.extend({
    accounting: AccountingTypeModel,
    expenditurePurpose: ExpenditurePurposeModel,
  }).array();

export const ExpenditurePurposeOfSettlementStatisticsPresetFormSchema =
  ExpenditurePurposeOfSettlementStatisticsPresetBaseModel.pick({
    accountingId: true,
  }).extend({
    period: DateRangeSchema.nullish(),
    expenditurePurposeIds: z.string().uuid().array(),
    expenditurePurposeOfSettlementStatisticsIds: z.string().uuid().array(),
  });
